<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Self Screening</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
        <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Community Screening Tool</ion-card-subtitle>
      <ion-card-title>Covid-19</ion-card-title>
    </ion-card-header>

    <ion-card-content>
     Please provide accurate information, misleading/incorrect information may result in legal liability
     <form>
        <ion-item id="rounded" lines="none">
            <ion-label position="floating">Full name</ion-label>
            <ion-input name="full_name" v-validate="'required'" :value="new_screening.fullname" @ionInput="new_screening.fullname=$event.target.value"></ion-input>
        </ion-item>
        <p class="error" :force-show="errors.has('full_name')">{{ errors.first('full_name') }}</p>
        <ion-item id="rounded" lines="none">
            <ion-label position="floating">Physical Address</ion-label>
            <ion-input name="physical_address" v-validate="'required'" :value="new_screening.address" @ionInput="new_screening.address=$event.target.value"></ion-input>
        </ion-item>
        <p class="error" :force-show="errors.has('physical_address')">{{ errors.first('physical_address') }}</p>
        <ion-item id="rounded" lines="none">
            <ion-label position="floating">Mobile Number</ion-label>
            <ion-input name="mobile_number" v-validate="'required'" :value="new_screening.mobile_number" @ionInput="new_screening.mobile_number=$event.target.value"></ion-input>
        </ion-item>
        <p class="error" :force-show="errors.has('mobile_number')">{{ errors.first('mobile_number') }}</p>
        <ion-item id="rounded" lines="none">
            <ion-label position="floating">Emergency Number</ion-label>
            <ion-input name="emergency_number" v-validate="'required'" :value="new_screening.emergency_number" @ionInput="new_screening.emergency_number=$event.target.value"></ion-input>
        </ion-item>
        <p class="error" :force-show="errors.has('emergency_number')">{{ errors.first('emergency_number') }}</p>
        <br/>
        <br/>
        <ion-radio-group :value="new_screening.contacted" @ionChange="new_screening.contacted=$event.target.value">
            <ion-list-header>
                <ion-label>
                In the past 2 weeks have you been in close contact with someone who tested positive for Covid-19?
                </ion-label>
            </ion-list-header>
            <ion-item>
                <ion-label>Yes</ion-label>
                <ion-radio value="yes"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>No</ion-label>
                <ion-radio value="no"></ion-radio>
            </ion-item>
        </ion-radio-group>
        <br/>
        <ion-button @click="submitForm" expand="full">Submit</ion-button>
        </form>
    </ion-card-content>
  </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>
import Modal from './ResultsModal'

export default {
    name:'screening',
    data(){
        return {
            new_screening:{
                fullname:'',
                physical_address:'',
                mobile_number:'',
                emergency_number:'',
                contacted:'',
                status:'PROCESSING'
            }
        }
    },
    methods:{
        showModal(){
            return this.$ionic.modalController.create(
                {
                    component:Modal,
                    componentProps:{
                        propsData:{
                            title:'Self Screening',
                            message:'Thank you for participating, your information is being processed and you may be contacted by our call center with further instructions',
                            closeMe: () => {
                                this.$ionic.modalController.dismiss()
                            },
                            result:'success'
                        }
                    }
                }
            ).then(m=>m.present());
        },
        submitForm(){
            this.$validator.validateAll().then((res)=>res && this.saveScreening());
        },
        saveScreening(){
            return this.$ionic.loadingController
            .create({
            message: 'Please wait...',
            })
            .then(loading => {
                loading.present();
                const base_url=this.$store.get('base_url');

                this.$http.post(base_url+'/api/screenings/',this.new_screening)
                .then((res)=>console.log(res))
                .then(()=>loading.dismiss())
                .then(()=>this.showModal())
                .catch((err)=>{loading.dismiss();this.showModal();console.log(err)});
            })
        }
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
  margin-left: 0px;
  margin-right: 0px;
}
.error{
  padding-left: 10px;
  text-transform: uppercase;
  color: red;
  font-size: 0.7em;
}
</style>